<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.qualitySamplePlan.new") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/qualitySamplePlan', query:{id: qualityPlanStatus.id}}">
              <span>{{$t('tlt.qualitySamplePlan.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('qualityPlan')"
          >
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.sure')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div class="card">
        <div class="card-body">
          <form>
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planCode')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.planCode"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planDate')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.planDateStr"
                />
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planPlant')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.locName"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planShift')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.planShift"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.itemName')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.itemName"
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="card my-1">
        <div class="card-header"><h6>{{ $t("tlt.qualitySamplePlan.new") }}</h6></div>
        <div class="card-body">
          <div class="row">
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualitySamplePlan.sampleTime')}}：
              </label>
              <mmf-datetimepicker v-model="qualitySamplePlanTemp.sampleTime"></mmf-datetimepicker>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualitySamplePlan.sampleName')}}:
              </label>
              <input
                name="sampleName"
                :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('sampleName') }"
                v-model="qualitySamplePlanTemp.sampleName"
                type="text"
              />
              <span
                v-show="errors.has('sampleName')"
                class="lbl-obg"
              >{{ errors.first('sampleName') }}</span>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualitySamplePlan.sampleUser')}}:
              </label>
              <input
                name="samplePerson"
                :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('samplePerson') }"
                v-model="qualitySamplePlanTemp.samplePerson"
                type="text"
              />
              <span
                v-show="errors.has('samplePerson')"
                class="lbl-obg"
              >{{ errors.first('samplePerson') }}</span>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualitySamplePlan.furnaceName')}}:
              </label>
              <select
                id="furnaceName"
                name="furnaceName"
                :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('furnaceName') }"
                v-model="qualitySamplePlanTemp.furnaceName"
                type="text"
              >
                <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
              </select>
              <span
                v-show="errors.has('furnaceName')"
                class="lbl-obg"
              >{{ errors.first('furnaceName') }}</span>
            </div>
            <!-- <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualitySamplePlan.furnaceBatch')}}:
              </label>
              <input
                id="furnaceBatch"
                name="furnaceBatch"
                :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('furnaceBatch') }"
                v-model="qualitySamplePlanTemp.furnaceBatch"
                type="text" 
                :disabled="isDisable"
              />
              <span
                v-show="errors.has('furnaceBatch')"
                class="lbl-obg"
              >{{ errors.first('furnaceBatch') }}</span>
            </div> -->
            <div class="col-lg-12 align-self-end">
              <div class="float-lg-right">
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click="save('qualitySamplePlan')"
                >
                  <i class="fa fa-fw fa-lg fa-save"></i>
                  <span class="text">{{$t('btn.basic.save')}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="qualityItemResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualitySamplePlan"
                inline-actions-disabled
                singleChoice
                disableDelete
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <button
                    v-b-modal.modal-2
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength !=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.basic.delete") }}</span>
                  </button>
                  <button
                    v-b-modal.modal-1
                    :disabled="slotProps.checkedLength ==0"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualitySamplePlan.sent") }}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" centered title="确认报检" @ok="Sent('qualitySamplePlan')">
      <div class="d-block text-center">
        <h5>报检后数据将无法修改，是否确认报检？</h5>
      </div>
    </b-modal>
    <b-modal id="modal-2" centered title="确认报检" @ok="Delete('qualitySamplePlan')">
      <div class="d-block text-center">
        <h5>是否确认删除？</h5>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { gridFields } from "@/model/prd/qualityMgt/pelletizing/QualitySamplePlan";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualitySamplePlan";
import MmfTable from "@/components/MmfTable";
// import qualityItem from "@/model/prd/qualityMgt/"

import MmfDatetimepicker from "@/components/MmfDatetimepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualitySamplePlan/getField",
  mutationType: "qualitySamplePlan/updateField"
});

export default {
  name: "qualitySamplePlanList",
  data() {
    return {
      qualitySamplePlanTemp: {},
      // isDisable:true
    };
  },
  components: { MmfTable, MmfDatetimepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.qualitySamplePlan.rows,
      tableColumns: gridFields,
      entity: state => state.qualitySamplePlan.entity,
            baseModuleUrl: state => state.qualitySamplePlan.baseModuleUrl,
      qualityPlanStatus: state => state.qualitySamplePlan.qualityPlanStatus,
      
    })
  },
  methods: {
    ...mapActions("qualitySamplePlan", ["Save", "Sent", "Delete"]),
    ...mapActions("base", ["MMFbackToList"]),

    clear() {
      this.qualitySamplePlanTemp = {};
      this.qualitySamplePlanTemp.sampleTime = "";
    },
    save(moudle) {                  
      this.sampleTime = this.qualitySamplePlanTemp.sampleTime;
      this.sampleCode = this.qualitySamplePlanTemp.sampleCode;
      this.sampleName = this.qualitySamplePlanTemp.sampleName;
      this.samplePerson = this.qualitySamplePlanTemp.samplePerson;
      this.furnaceName = this.qualitySamplePlanTemp.furnaceName;
      this.furnaceBatch = this.qualitySamplePlanTemp.furnaceBatch;
      this.Save(moudle).then(() => {
        this.clear();
      });
    },
  },
  created() {
    this.$store.commit("qualitySamplePlan/setNewEntity", {}, { root: true });

    const context = this.$store;
    const id = this.$route.query.id; // 从当前的路由中获取参数 id
    const baseModuleUrl = this.baseModuleUrl;

    context
      .dispatch("api/get", {
        url:
          baseModuleUrl +
          "/qualityPlan/findById/" +
          id
      })
      .then(response => {
        context.commit("qualitySamplePlan" + "/setRows", response.qualitySamplePlans);
        context.dispatch("qualitySamplePlan/qualityPlanStatus", response);
      });
      
      
  },
  mounted() {
    if (this.qualityPlanStatus.qualityItem.craftType == "Q") {
      document.getElementById("furnaceName").disabled = true;
      document.getElementById("furnaceBatch").disabled = true;
    }
  }
};
</script>
